import { inject } from 'mobx-react';
import propTypes from 'prop-types';

import { getBSLImageURL } from '../../../../../utils/utils';
import { AddToFavBlock } from '../AddToFavBlock/AddToFavBlock.jsx';
import { CompareCheckbox } from '../../CompareCheckbox/CompareCheckbox.jsx';
import { format } from '@pes-ui/components/dist/collection/globals/utils/formatters/currency';
import { AddToCartBlock } from '../AddToCartBlock/AddToCartBlock.jsx';
import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';

const _SubstitutionProduct = ({ product, substStore, labelsStore, locale, optionsStore }) => {
  const { cardCompare, giftlistTableQty, qtyLabel } = labelsStore;
  const type = substStore.sectionType;
  const isShowPrice = product.sku.price && product.sku.currency;
  const rangeUrl = `${product.rangeLink}`;
  const productUrl = product.sku.productUrl;
  const channelSightBtnEnabled = optionsStore.isCartTransferAvailable;

  return (
    <div className="subst-product">
      <a className="subst-product__link" href={productUrl}>
        <img className="subst-product__image" src={getBSLImageURL(product.sku.pictureUrl, 64)} alt={product.sku.commercialReference} />
      </a>

      <div className="subst-product__main">

        <div>
          <a href={productUrl}>
            <p className="subst-product__title">{product.sku.commercialReference}</p>
          </a>
          <p className="subst-product__desc">{product.sku.description}</p>
        </div>

        {isShowPrice
          && (
            <div className="subst-product__price indent-words">
              <span>{format(product.sku.price, locale)}</span>
              <span>{product.sku.currency}</span>
            </div>
          )}

        <div className="subst-product__qty indent-words">
          <span className="qty-mobile">{giftlistTableQty}</span>
          <span className="qty-desktop">
            {qtyLabel}
            :
          </span>
          <span data-autotests-id="cart-substitution-product-qty">{product.quantity}</span>
        </div>

        <div className="subst-product__action-container">
          <a className="subst-product__range-link pes-link indent-words" href={rangeUrl}>
            <PesIcon size={pesIconSizes.NANO}>
              arrow2_right
            </PesIcon>
            <span className="range-label">{labelsStore.productRangeLabel}</span>
            <span dangerouslySetInnerHTML={{ __html: product.range.formattedDisplayName }} />
          </a>

          {type === 'product'
            && (
              <>
                {channelSightBtnEnabled ? <AddToCartBlock substStore={substStore} labelsStore={labelsStore}/> : <AddToFavBlock substStore={substStore} labelsStore={labelsStore}/>}
                <CompareCheckbox card={substStore.comparableCard} label={cardCompare} />
              </>
            )}
        </div>
      </div>
    </div>
  );
};

_SubstitutionProduct.propTypes = {
  product: propTypes.shape({
    range: propTypes.shape({
      formattedDisplayName: propTypes.string.isRequired,
      rangeUrl: propTypes.string.isRequired
    }),

    rangeLink: propTypes.string,

    sku: propTypes.shape({
      pictureUrl: propTypes.string.isRequired,
      productUrl: propTypes.string,
      commercialReference: propTypes.string.isRequired,
      description: propTypes.string,
      price: propTypes.oneOfType([propTypes.string, propTypes.number]),
      currency: propTypes.string
    }),
    quantity: propTypes.number.isRequired
  }).isRequired,

  substStore: propTypes.object,

  labelsStore: propTypes.shape({
    cardCompare: propTypes.string.isRequired,
    giftlistTableQty: propTypes.string.isRequired,
    qtyLabel: propTypes.string.isRequired,
    productRangeLabel: propTypes.string.isRequired
  }).isRequired,

  locale: propTypes.string.isRequired,

  optionsStore: propTypes.shape({
    isCartTransferAvailable: propTypes.bool.isRequired
  }).isRequired
};

_SubstitutionProduct.defaultProps = {
  substStore: { sectionType: 'group' }
};

export const SubstitutionProduct = inject((allStores) => ({
  locale: allStores.optionsStore.locale,
  labelsStore: allStores.labelsStore,
  optionsStore: allStores.optionsStore
}))(_SubstitutionProduct);
